import React, { useState, useEffect } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Box,
  Autocomplete,
  TextField,
} from '@mui/material';
import SimpleMap from '../../components/Map/SimpleMap';
import axios from 'axios';
import { Select as SelectInt } from '../../components/Select';

const specialtyDescriptions: Record<string, string> = {
  'Clínica geral':
    'Diagnostica e efetua todos os tipos de tratamentos odontológicos, em geral.',
  Ortodontia: 'Trata o alinhamento dos dentes e correções da mordida.',
  Endodontia:
    'Atua no tratamento dos canais das raízes dos dentes. É realizada a remoção do nervo, a limpeza e obturação dos canais.',
  Periodontia:
    'Tratamento das doenças da gengiva e do osso de suporte dos dentes. Realiza prevenção e tratamento, como, por exemplo, a remoção do tártaro e inflamações na gengiva.',
  Urgência:
    'São aqueles que necessitam de atendimento imediato e podem ser realizados em Pronto Socorro Odontológico (exemplos: hemorragia, dor intensa, recolocação de próteses, entre outros).',
  Odontopediatria:
    ' Tratamento da saúde bucal dos bebês e das crianças até 15 anos, realizando todos os tratamentos necessários.',
  Radiologia:
    'Realiza os exames de diagnóstico através das radiografias odontológicas (Raio-x).',
  Prótese:
    'Tratamento e recuperação de dentes perdidos ou partes dele, por peças dentárias artificiais.',
  'Cirugia Bucomaxilofacial':
    'Remoção de dentes (incluindo os sisos), raízes, correções ósseas, biópsias e cirurgias bucais de pequeno porte.',
  'Saúde coletiva':
    'Realiza uma avaliação de bem aprofundada para descobrir e diagnosticar as doenças na boca (dente, gengiva, lábios, céu da boca,  bochecha e dentro do osso).',
  'Pacientes especiais':
    'Atende pacientes com necessidades especiais, como síndrome de down, paralisia celebral, autismo....',
};

/* const estados = [
  { sigla: 'AC', nome: 'Acre' },
  { sigla: 'AL', nome: 'Alagoas' },
  { sigla: 'AP', nome: 'Amapá' },
  { sigla: 'AM', nome: 'Amazonas' },
  { sigla: 'BA', nome: 'Bahia' },
  { sigla: 'CE', nome: 'Ceará' },
  { sigla: 'DF', nome: 'Distrito Federal' },
  { sigla: 'ES', nome: 'Espírito Santo' },
  { sigla: 'GO', nome: 'Goiás' },
  { sigla: 'MA', nome: 'Maranhão' },
  { sigla: 'MT', nome: 'Mato Grosso' },
  { sigla: 'MS', nome: 'Mato Grosso do Sul' },
  { sigla: 'MG', nome: 'Minas Gerais' },
  { sigla: 'PA', nome: 'Pará' },
  { sigla: 'PB', nome: 'Paraíba' },
  { sigla: 'PR', nome: 'Paraná' },
  { sigla: 'PE', nome: 'Pernambuco' },
  { sigla: 'PI', nome: 'Piauí' },
  { sigla: 'RJ', nome: 'Rio de Janeiro' },
  { sigla: 'RN', nome: 'Rio Grande do Norte' },
  { sigla: 'RS', nome: 'Rio Grande do Sul' },
  { sigla: 'RO', nome: 'Rondônia' },
  { sigla: 'RR', nome: 'Roraima' },
  { sigla: 'SC', nome: 'Santa Catarina' },
  { sigla: 'SP', nome: 'São Paulo' },
  { sigla: 'SE', nome: 'Sergipe' },
  { sigla: 'TO', nome: 'Tocantins' },
]; */

const options = Object.entries(specialtyDescriptions).map(([key, desc]) => ({
  label: key.charAt(0).toUpperCase() + key.slice(1),
  description: desc,
  value: key,
}));

const Pesquisa: React.FC = () => {
  const [location, setLocation] = useState('');
  const [answers, setAnswers] = useState<Record<number, boolean>>({});
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [results, setResults] = useState<
    Array<{
      telefone: any;
      endereco: any;
      longitude: any;
      latitude: any;
      nome: string;
      especialidade: string;
      local: string;
    }>
  >([]);
  const [resolvedAddress, setResolvedAddress] = useState('');
  const [state, setState] = useState<any>([]);
  const [city, setCity] = useState<any>([]);
  const [especialidade, setSpeciality] = useState<number>(44);
  const [selectedUF, setSelectedUF] = useState<string>('');
  const [selectedCity, setSelectedCity] = useState<string>('');
  const [estados, setEstados] = useState<any>([]);

  const url = process.env.REACT_APP_URL_BASE;
  const token = process.env.REACT_APP_TOKEN_S4E_V2;

  const [specialty, setSpecialty] = useState<{
    label: string;
    description: string;
    value: string;
  } | null>(null);

  /* const handleChangeUF = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedUF(e.target.value);
    getCity(e.target.value);
    console.log('[UF Selecionada]:', e.target.value);
  }; */
  useEffect(() => {
    if (selectedUF) {
      getCity(selectedUF);
      console.log('[UF Selecionada]:', selectedUF);
    }
  }, [selectedUF]);

  const questions = [
    {
      id: 1,
      text: 'A consulta é para você?',
      specialtyHint: null,
    },
    {
      id: 2,
      text: 'Está com dor de dente, sensibilidade ou desconforto forte?',
      specialtyHint: 'DIAGNOSTICO',
      Idespecialidade: 2,
    },
    {
      id: 3,
      text: 'Percebe dentes tortos, desalinhados ou sente incômodo ao morder?',
      specialtyHint: 'PREVENÇÃO',
      Idespecialidade: 2,
    },
    {
      id: 4,
      text: 'Notou sangramento na gengiva, inchaço ou mau hálito frequente?',
      specialtyHint: 'ENDODONTIA',
      Idespecialidade: 5,
    },
    {
      id: 5,
      text: 'Você ou seu(sua) filho(a) tem menos de 15 anos?',
      specialtyHint: 'ODONTOPEDIATRIA',
      Idespecialidade: 3,
    },
    {
      id: 6,
      text: 'Está com prótese solta, falta de dente ou dente quebrado?',
      specialtyHint: 'PRÓTESE',
      Idespecialidade: 7,
    },
    {
      id: 7,
      text: 'Já fez ou precisa fazer radiografia odontológica?',
      specialtyHint: 'radiologia',
      Idespecialidade: 11,
    },
    {
      id: 8,
      text: 'A consulta é para alguém com necessidades especiais (ex: autismo, paralisia cerebral)?',
      specialtyHint: 'pacientes especiais',
      Idespecialidade: 9,
    },
    {
      id: 9,
      text: 'Está com dor urgente, sangramento intenso ou sofreu algum trauma?',
      specialtyHint: 'urgência',
      Idespecialidade: 9,
    },
    {
      id: 10,
      text: 'Precisa remover um dente, siso ou fazer alguma cirurgia bucal?',
      specialtyHint: 'CIRURGIA BUCO MAXILO FACIAL',
      Idespecialidade: 32,
    },
    {
      id: 11,
      text: 'Quer apenas uma avaliação geral da sua saúde bucal?',
      specialtyHint: 'Clínica geral',
      Idespecialidade: 44,
    },
  ];

  const handleAnswer = (value: boolean) => {
    const id = questions[currentQuestion].id;
    setAnswers(prev => ({ ...prev, [id]: value }));
    setCurrentQuestion(prev => prev + 1);
  };

  const getSuggestedSpecialty = () => {
    const priorityOrder = [
      'urgência',
      'Cirugia Bucomaxilofacial',
      'endodontia',
      'periodontia',
      'ortodontia',
      'prótese',
      'radiologia',
      'odontopediatria',
      'pacientes especiais',
      'Clínica geral',
    ];
    let retorno: any = [];

    for (const specialty of priorityOrder) {
      const match = questions.find(
        q => q.specialtyHint === specialty && answers[q.id],
      );
      if (match) {
        retorno = {
          especialidade: specialty,
          id: match.Idespecialidade,
        };
      }
    }
    retorno = {
      especialidade: 'Clínica geral',
      id: 44,
    };
    return retorno;
  };
  useEffect(() => {
    getUfs();
  }, []);

  const getUfs = async () => {
    try {
      const response = await axios.get(
        `${url}/api/redeatendimento/UFs?token=${token}`,
      );
      console.log('Retorno: ', response.data);
      setEstados(response.data.dados.filter((uf: any) => uf.Id !== 0));
    } catch (error) {
      console.error('Erro ao buscar UFs:', error);
      return [];
    }
  };

  const getCity = async (uf: string) => {
    try {
      const response = await axios.get(
        `${url}/api/redeatendimento/Municipios?token=${token}&ufID=${uf}`,
      );
      console.log('Retorno: ', response.data);
      setCity(response.data.dados);
    } catch (error) {
      console.error('Erro ao buscar cidades:', error);
      return [];
    }
  };
  const getEndereco = async (cep: string) => {
    if (cep.length === 8) {
      try {
        const response = await axios.get(
          `${url}/api/redeatendimento/Endereco?token=${token}&ufID=${cep}`,
        );
        const data = response.data.dados;
        const fullAddress = `${data.Logradouro}, ${data.Bairro}, ${data.Municipio} - ${data.Uf}`;
        setResolvedAddress(fullAddress);
        setState(data.IdUf);
        setCity(data.IdMunicipio);
      } catch (error) {
        console.error('Erro ao buscar Cep:', error);
        return [];
      }
    }
  };

  useEffect(() => {
    if (currentQuestion >= questions.length) {
      const suggested = getSuggestedSpecialty();
      console.log('[Especialidade sugerida]:', suggested.especialidade);
      console.log(options);

      const matchedOption = options.find(
        opt =>
          opt.value.toLowerCase() === suggested.especialidade.toLowerCase(),
      );

      setSpecialty(matchedOption || null);
      setSpeciality(suggested.id);
    }
  }, [currentQuestion]);

  const handleSearch = async () => {
    if (!(location || (selectedUF && selectedCity)) || !specialty) {
      alert('Preencha a localização e selecione a especialidade!');
      return;
    }

    console.log('[Local informado]:', location);
    console.log('[Especialidade selecionada]:', specialty);

    if (!city || !state || !specialty) return;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_OG_API_URL}/info/RedeVendas?&ufId=${selectedUF}&municipioId=${selectedCity}&especialidadeId=${especialidade}&quantidade=5`,
      );
      const data = await res.json();
      console.log('[Resposta da API]:', data);

      const normalize = (text: string) =>
        text
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');

      const resultado = data.clinicas.map(clinica => ({
        nome: clinica.nomeFantasia,
        especialidade: clinica.dentistas[0]?.especialidades ?? 'Não informado',
        local: clinica.bairro?.trim() ?? '',
        latitude: parseFloat(clinica.latitude.replace(',', '.')),
        longitude: parseFloat(clinica.longitude.replace(',', '.')),
        endereco: clinica.endereco ?? '',
        telefone: clinica.telefone ?? '',
      }));

      setResults(resultado);
    } catch (error) {
      console.error('Erro ao buscar dados da API:', error);
      alert('Erro ao buscar dados. Tente novamente mais tarde.');
    }
  };

  let debounceTimer: NodeJS.Timeout;

  useEffect(() => {
    clearTimeout(debounceTimer);

    debounceTimer = setTimeout(() => {
      const query = location.trim();
      const cep = query.replace(/\D/g, '');

      if (cep.length === 8) {
        getEndereco(cep);
      } else if (query.length > 3) {
        const parts = query.split(' ');
        const possibleUF = parts[parts.length - 1].toUpperCase();
        const cidade = parts.slice(0, parts.length - 1).join(' ');

        if (cidade.length > 2 && possibleUF.length === 2) {
          setResolvedAddress(`${cidade} - ${possibleUF}`);
        } else {
          setResolvedAddress('');
        }
      } else {
        setResolvedAddress('');
      }
    }, 500);

    return () => clearTimeout(debounceTimer);
  }, [location]);

  return (
    <div className="p-7 mb-5 mt-10 bg-white rounded-xl shadow-md max-w-6xl mx-auto">
      <div className="bg-blue-5 rounded-sm mt-10">
        <h2 className="text-xl p-8 font-bold text-blue-900 flex items-center gap-2">
          <span role="img" aria-label="search">
            🔍
          </span>
          Busca de Dentista
        </h2>
      </div>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4 items-start">
        <div className="bg-gray-100 p-4 rounded-md flex flex-col gap-3">
          <p className="text-1xl sm:text-base text-blue-900 font-semibold">
            Responda o assistente abaixo e obtenha a especialidade que precisa:
          </p>

          {currentQuestion < questions.length ? (
            <div className="flex flex-col gap-3">
              <span className="text-sm sm:text-base">
                {questions[currentQuestion].text}
              </span>
              <div className="flex gap-3">
                <button
                  onClick={() => handleAnswer(true)}
                  className="px-3 py-1.5 rounded text-sm bg-green-100 text-green-600"
                >
                  👍 Sim
                </button>
                {currentQuestion > 0 && (
                  <button onClick={() => setCurrentQuestion(prev => prev - 1)}>
                    ⬅ Voltar
                  </button>
                )}
                <button
                  onClick={() => handleAnswer(false)}
                  className="px-3 py-1.5 rounded text-sm bg-red-100 text-red-600"
                >
                  👎 Não
                </button>
                <p className="text-sm text-gray-500">
                  Pergunta {currentQuestion + 1} de {questions.length}
                </p>
              </div>
            </div>
          ) : (
            <div className="mt-4 text-sm text-gray-700">
              <strong>Especialidade recomendada:</strong>{' '}
              {getSuggestedSpecialty().especialidade}
            </div>
          )}
        </div>

        <Box p={2} bgcolor="#f7f7f7" color="primary" borderRadius={2}>
          <Typography fontWeight="bold" color="primary" mb={1}>
            Escolha uma especialidade abaixo
          </Typography>

          <Autocomplete
            options={options}
            getOptionLabel={option => option.label}
            value={specialty}
            onChange={(_, newValue) => setSpecialty(newValue)}
            renderOption={(props, option) => (
              <Box
                component="li"
                {...props}
                sx={{ flexDirection: 'column', alignItems: 'flex-start' }}
              >
                <Typography fontWeight="bold" color="primary">
                  {option.label}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {option.description}
                </Typography>
              </Box>
            )}
            renderInput={params => (
              <TextField {...params} label="Especialidade" variant="outlined" />
            )}
          />

          {specialty && (
            <Box mt={2} p={2} bgcolor="#f7f7f7" borderRadius={2}>
              <Typography variant="subtitle1" fontWeight="bold" color="primary">
                {specialty.label}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {specialty.description}
              </Typography>
            </Box>
          )}
        </Box>
      </div>

      <div className="display-flex justify-between p-5 mt-5 ">
        <div className="mt-6 grid md:grid-cols-2 gap-4 items-center">
          <div>
            <label className="flex text-sm text-blue-700 font-semibold mb-1">
              Onde você deseja ser atendido?
            </label>
            <input
              type="text"
              placeholder="Digite seu CEP"
              value={location}
              onChange={e => setLocation(e.target.value)}
              className="p-2 border-b w-1/2  border-blue-500 outline-none"
            />
          </div>
          {resolvedAddress && (
            <p className="text-sm text-blue-600 mt-1">{resolvedAddress}</p>
          )}
        </div>

        <p className="flex text-sm w-1/2 text-blue-700 mt-3 py-3 justify-evenly font-semibold mb-1">
          Ou
        </p>

        <div>
          <div className="w-1/2 mx-auto my-4">
            <label className="block text- font-medium text-blue-700 mb-1">
              Selecione um estado:
            </label>
            <SelectInt
              label="Estado"
              options={[]}
              optionsFull={estados}
              onChange={e => {
                setSelectedUF(e.target.value);
              }}
              placeholder="Selecione um estado"
            />
          </div>
          <div className="w-1/2 mx-auto my-4">
            <label className="block text- font-medium text-blue-700 mb-1">
              Selecione uma cidade:
            </label>
            <SelectInt
              label="Cidade"
              options={[]}
              optionsFull={city}
              onChange={e => {
                setSelectedCity(e.target.value);
              }}
              placeholder="Selecione uma cidade"
            />
          </div>
        </div>
      </div>

      <div className="mt-6 flex justify-end">
        <button
          onClick={handleSearch}
          disabled={!(location || (selectedUF && selectedCity)) || !specialty}
          className={`px-6 py-2 rounded ${
            !(location || (selectedUF && selectedCity)) || !specialty
              ? 'bg-gray-300 text-white cursor-not-allowed'
              : 'bg-blue-600 text-white hover:bg-blue-700'
          }`}
        >
          BUSCAR
        </button>
      </div>

      {results.length > 0 && (
        <>
          <div className="mt-10 bg-white p-4 rounded shadow-md">
            <h3 className="text-lg font-bold mb-4 text-blue-800">
              Dentistas encontrados:
            </h3>
            <ul className="space-y-3">
              {results.map((dentista, index) => (
                <li
                  key={index}
                  className="p-3 bg-gray-100 rounded border border-gray-200"
                >
                  <p className="font-semibold text-blue-900">{dentista.nome}</p>
                  <p className="text-sm text-gray-700">
                    Especialidade(s): {dentista.especialidade}
                  </p>
                  <p className="text-sm text-gray-700">
                    Endereço: {dentista.endereco}
                  </p>
                  <p className="text-sm text-gray-700">
                    Telefone: {dentista.telefone}
                  </p>
                  <p className="text-sm text-gray-700">
                    Bairro: {dentista.local}
                  </p>
                </li>
              ))}
            </ul>
          </div>

          <SimpleMap
            markers={results.map((d, index) => ({
              id: String(index),
              name: d.nome,
              position: { lat: d.latitude, lng: d.longitude },
              description: d.especialidade,
              endereco: d.endereco,
              telefone: d.telefone,
            }))}
          />
        </>
      )}
    </div>
  );
};

export default Pesquisa;
